(function () {
  const bar = document.getElementById('sticky-atc');
  const btn = document.getElementById('sticky-atc-btn');
  if (!bar || !btn) return;

  // Only run on mobile
  if (window.innerWidth >= 750) return;
  bar.style.display = 'block';

  // Watch native ATC button — hide sticky when it's visible
  const nativeAtc = document.querySelector('[name="add"]') || document.querySelector('.product-form__submit');
  if (nativeAtc) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
        bar.setAttribute('aria-hidden', String(entry.isIntersecting));
      },
      { threshold: 0.1 }
    );
    observer.observe(nativeAtc);
  }

  // Sync variant changes from Dawn's native variant picker
  document.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (!variant) return;
    btn.dataset.variantId = variant.id;
    btn.disabled = !variant.available;
    btn.textContent = variant.available
      ? btn.dataset.addText || 'Add to cart'
      : btn.dataset.soldText || 'Sold out';
  });

  // ATC click handler
  btn.addEventListener('click', () => {
    if (btn.disabled) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 }),
    })
      .then((r) => r.json())
      .then(() => {
        // Trigger Dawn's cart drawer open
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const drawerTrigger = document.querySelector('[data-cart-open]') || document.querySelector('.cart-notification');
        if (drawerTrigger) drawerTrigger.click();
      })
      .catch(console.error);
  });
})();
